// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchChargements ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/chargement`).then(({ data }) => {
      // commit("addChargements", data);
      return data
    });
  },
  createChargement ({ commit }, chargement) {
    return post('/canal/chargement', chargement)
      .then(({ data }) => {
        commit('addChargement', data)
      })
  },
  updateChargement ({ commit }, chargement) {
    return put(`/canal/chargement/${chargement.id}`, chargement)
      .then(({ data }) => {
        commit('replaceChargement', data)
      })
  },
  createOrUpdateChargement ({ dispatch }, chargement) {
    if (chargement.id !== undefined) {
      return dispatch('updateChargement', chargement)
    } else {
      return dispatch('createChargement', chargement)
    }
  },
  selectChargement ({ commit }, chargement) {
    commit('setChargement', chargement)
  }
}
